import { createContext, useContext, useEffect } from "react";

/** The organisation a page shows and its state, told to the shell so its navigation never offers an area of a
 * deactivated organisation (those answer Not found); the page body does the same. */
export type ShownOrganization = { id: string; state: string } | null;

export const ShowOrganization = createContext<(org: ShownOrganization) => void>(() => {});

export function useShowOrganization(org: ShownOrganization) {
  const show = useContext(ShowOrganization);
  const id = org?.id;
  const state = org?.state;
  useEffect(() => {
    show(id && state ? { id, state } : null);
  }, [show, id, state]);
}
